export default __webpack_public_path__ + "static/media/decoCircle.56b3f433.svg";